import { useCapabilitiesStore } from '@/stores/capabilities'
import { FEATURES, useFeaturesStore } from '@/stores/features'
import { useRoomStore } from '@/stores/room'

interface UseMicrophoneSensitivityStateProps {
  memberId: string
}

export const useMicrophoneSensitivityState = ({
  memberId,
}: UseMicrophoneSensitivityStateProps) => {
  const selfMemberId = useRoomStore(state => state.memberId)
  const isSelf = memberId === selfMemberId

  const microphoneSensitivityCapability = useCapabilitiesStore(state =>
    isSelf
      ? state.selfMicrophoneSensitivityCapability
      : state.memberMicrophoneSensitivityCapability,
  )

  const isFeatureDisabled = useFeaturesStore(state =>
    isSelf
      ? state.disabled.SELF_MICROPHONE_SENSITIVITY ===
        FEATURES.SELF_MICROPHONE_SENSITIVITY
      : state.disabled.MEMBER_MICROPHONE_SENSITIVITY ===
        FEATURES.MEMBER_MICROPHONE_SENSITIVITY,
  )

  // visible if one of the capabilities is enabled and FF is enabled
  const isMicrophoneSensitivityVisible =
    !isFeatureDisabled && microphoneSensitivityCapability

  const isMicrophoneSensitivityEnabled = microphoneSensitivityCapability

  return {
    isMicrophoneSensitivityEnabled,
    isMicrophoneSensitivityVisible,
  }
}
